<template>
  <div class="grid grid-cols-8 items-center gap-4 min-h-5">
    <Label :for="id" class="col-span-2 text-right"> {{ label }} </Label>
    <Slider v-model="valueWrapper" :min="min" :max="max" :step="step" class="col-span-5" @update:model-value="update" />
    <div class="col-span-1 -ml-2 flex items-center justify-center">
      <slot></slot>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { Label } from '~/components/ui/label';
import { Slider } from '~/components/ui/slider';

const value = defineModel<number>({ required: true });
defineProps({
  id: String,
  label: String,
  min: {
    type: Number,
    default: 1,
  },
  max: {
    type: Number,
    default: 9,
  },
  step: {
    type: Number,
    default: 1,
  },
});
const valueWrapper = ref([value.value]);
watch(valueWrapper, (val) => {
  value.value = val[0];
});

const emit = defineEmits(['update:modelValue']);
const update = (payload: number[] | undefined) => {
  emit('update:modelValue', payload);
};
</script>
